<div id="appContainer">
    <app-header id="header"></app-header>
    <div id="routerContainer" style="flex: 1; overflow: hidden;">
        <router-outlet></router-outlet>
    </div>
    <app-footer id="footer" *ngIf="isAuth"></app-footer>
</div>
